import { formatReadableDate } from '../queries';
import { BASE_URL } from '../thunk';
import { BULK_UPLOAD, jobDetailsInputs } from './constants';

export const getDefaultValues = (jobData, actionType) => {
  if (!jobData) return {};
  return Object.entries(jobData).reduce<
    Record<string, { value: any; code: string }>
  >((acc, [key, value]) => {
    if (['receivedDate', 'availableTill'].includes(key)) {
      value = formatReadableDate(value);
    }

    if (key === 'jobType' && actionType === BULK_UPLOAD) {
      acc.jobDescription = { value, code: 'jobDescription' };
      return acc;
    }

    if (value !== undefined && value !== null && value !== '') {
      acc[key] = { value, code: key };
    }
    return acc;
  }, {});
};

export const getJobDetailsApi = (jobId: string, actionType?: string) => {
  switch (actionType) {
    case BULK_UPLOAD:
      return `${BASE_URL}/bulk-allocation/details/${jobId}`;
    default:
      return `${BASE_URL}/jobs/${jobId}/details`;
  }
};

export const normaliseJobDetails = (details, actionType?: string) => {
  if (actionType === BULK_UPLOAD) {
    return {
      ...details,
      downloadLink: details?.summaryDownloadUrl,
    };
  }

  return details;
};

export const getProgressValue = (
  jobData,
  formattedJobData,
  actionType?: string,
) => {
  switch (actionType) {
    case BULK_UPLOAD:
      return Number(jobData?.progress) || 0;
    default:
      return formattedJobData?.totalSteps
        ? Math.round(
            (Number(formattedJobData?.currentStep) /
              Number(formattedJobData?.totalSteps)) *
              100,
          )
        : 0;
  }
};

export const getJobDetailsInputs = (actionType?: string) => {
  switch (actionType) {
    case BULK_UPLOAD:
      return jobDetailsInputs.filter(({ code }) =>
        ['jobDescription', 'status'].includes(code),
      );
    default:
      return jobDetailsInputs;
  }
};
